function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "primary-fill",
  fillRule: "nonzero",
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.5 0C6.94 0 0 6.94 0 15.5 0 24.06 6.94 31 15.5 31 24.06 31 31 24.06 31 15.5 31 6.94 24.06 0 15.5 0zm0 28.182c-7.01 0-12.682-5.672-12.682-12.682C2.818 8.49 8.49 2.818 15.5 2.818c7.01 0 12.682 5.672 12.682 12.682 0 7.01-5.672 12.682-12.682 12.682z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5 18.67c.775 0 1.41-.634 1.41-1.409V9.16c0-.775-.635-1.409-1.41-1.409-.775 0-1.41.634-1.41 1.41v8.101c0 .775.635 1.41 1.41 1.41z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15.5,
  cy: 21.947,
  r: 1.761
}));

const SvgIcError = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcError, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-error.700b274c.svg";
export { ForwardRef as ReactComponent };